import { createI18n } from 'vue-i18n'

// 載入語言
// import en from '@/lang/en.json'
import tw from '@/lang/tw.json'
import cn from '@/lang/cn.json'

const i18n = createI18n({
  locale: sessionStorage.getItem('locale') || 'zh-TW', // 設定語言
  fallbackLocale: 'zh-TW', // 若選擇的語言缺少翻譯則退回的語言
  messages: {
    // 'en-US': en,
    'zh-TW': tw,
    'zh-CN': cn,
  },
})
export default i18n
